import React, { useEffect } from 'react';
import { Hero } from './Hero';
import { PerspectiveSection } from './PerspectiveSection';
import { FoundationSection } from './FoundationSection';
import { PillarsSection } from './PillarsSection';
import { PurposeSection } from './PurposeSection';
import { DisciplineSection } from './DisciplineSection';
import { PathSection } from './PathSection';
import { FormationSection } from './FormationSection';
import { IdentitySection } from './IdentitySection';
import { ManifestoSection } from './ManifestoSection';
import { FinalCTA } from './FinalCTA';
import { Footer } from './Footer';
import { StickyCTA } from './StickyCTA';
import type { PillarPageContent } from '../types/pillarPage';
type PillarPageProps = {
  content: PillarPageContent;
};
export function PillarPage({
  content
}: PillarPageProps) {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, [content.slug]);
  return <div className="min-h-screen w-full bg-ink font-sans text-bone antialiased" style={{
    '--accent': content.accent.base,
    '--accent-deep': content.accent.deep,
    '--accent-ink': content.accent.ink
  } as React.CSSProperties} data-id="element-210" data-mp="4dp76gf4denv">
      <Hero content={content.hero} data-id="element-211" data-mp="2h4n3dpq579z2" />
      <main data-id="element-212" data-mp="2h3lm33ij9r8w">
        <PerspectiveSection content={content.perspective} data-id="element-213" data-mp="2h67vl8ozigtr" />
        <FoundationSection content={content.foundation} data-id="element-214" data-mp="2d434ohpx7yat" />
        <PillarsSection content={content.pillars} data-id="element-215" data-mp="1pcxp83nw7811" />
        <PurposeSection content={content.purpose} data-id="element-216" data-mp="1pdqxxa6ew7lt" />
        <DisciplineSection content={content.discipline} data-id="element-217" data-mp="1kee1pytnho6k" />
        <PathSection content={content.path} data-id="element-218" data-mp="1kfyvhm85533d" />
        <FormationSection content={content.formation} affiliateUrl={content.affiliateUrl} data-id="element-219" data-mp="1yef27d606tli" />
        <IdentitySection content={content.identity} data-id="element-220" data-mp="1tf2fcsf4tmix" />
        <ManifestoSection content={content.manifesto} data-id="element-221" data-mp="1tdhkt2sti3l2" />
        <FinalCTA content={content.finalCta} affiliateUrl={content.affiliateUrl} data-id="element-222" data-mp="39sj3l4ex7k0l" />
      </main>
      <Footer activePillar={content.slug} data-id="element-223" data-mp="34uhdhzj2ukfm" />
      <StickyCTA label={content.stickyCtaLabel} affiliateUrl={content.affiliateUrl} data-id="element-224" data-mp="34tg3lydss3zh" />
    </div>;
}